import { render, staticRenderFns } from "./SettingsOrderCategories.vue?vue&type=template&id=09e9b1bb&scoped=true"
import script from "./SettingsOrderCategories.vue?vue&type=script&lang=js"
export * from "./SettingsOrderCategories.vue?vue&type=script&lang=js"
import style0 from "./SettingsOrderCategories.vue?vue&type=style&index=0&id=09e9b1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9b1bb",
  null
  
)

export default component.exports